export default [
  // Main Page
  {
    path: 'analytics',
    name: 'website.analytics',
    component: () => import('@/views/website/analytics'),
  },
];
